import React from 'react';

import {RELATION_LEVEL_CAPTIONS} from 'src/modules/manage-entitlements/all-entitlements/presets/constants';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import Icon, {Icons} from '@pb/kit-component-icon';


import {
    entitlementDetailsViewLabel,
    entitlementDetailsViewOffsetContainer,
    entitlementDetailsViewToggle,
    entitlementDetailsViewToggleLabel,
} from '../entitlement-details-view.module.styl';

import {ResourcesList} from './resources-list';

import type {EntitlementGrant} from 'src/modules/entitlements/components/drawer/typedef';

type Props = {
    isExpanded: (grantId: string) => boolean,
    onToggleGrant: (grantId: string) => void,

    grants: EntitlementGrant[],

    onResourceClick: (resourceId: string) => void,
    onGrantClick: (grantId: string) => void,
};

export const GrantList = (props: Props) => {
    const {isExpanded, onToggleGrant, grants, onGrantClick, onResourceClick} = props;

    return (
        <ul>
            {grants.map(({id: grantId, name: grantName, resources, level}, i) => (
                <li key={i}>
                    <div className={entitlementDetailsViewToggle} onClick={() => onToggleGrant(grantId)}>
                        <Icon type={isExpanded(grantId) ? Icons.ANGLE_UP : Icons.ANGLE_DOWN}/>
                        <div className={`${entitlementDetailsViewToggleLabel} ${entitlementDetailsViewLabel}`}>
                            <EllipsisTextHint title={grantName}>
                                <a onClick={() => onGrantClick(grantId)}>{grantName}</a>
                            </EllipsisTextHint>
                        </div>
                        {level ? (
                            <b className={entitlementDetailsViewToggleLabel}>
                                ({RELATION_LEVEL_CAPTIONS[level]})
                            </b>
                        ) : null}
                    </div>
                    {isExpanded(grantId) ? (
                        <div className={entitlementDetailsViewOffsetContainer}>
                            <b>Resources</b>
                            <ResourcesList
                                resources={resources}
                                onResourceClick={onResourceClick}
                            />
                        </div>
                    ) : null}
                </li>
            ))}
        </ul>
    );
};
